import React, { useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TabType } from './types';
import { usePwdUserSettingsMultipleEndpoint } from './usePwdUserSettingsMultipleEndpoint';
import Skeleton from '@mui/material/Skeleton';
import TabSwitcher from './TabSwitcher';
import { isSDBAccount } from 'utils/misc';

const UserAndPassword = () => {
  const { t } = useTranslation('common', { keyPrefix: 'userAndPassword' });
  const [value, setValue] = useState<TabType>(TabType.GENERAL);

  const { isFetching, userAndPwdSettings } =
    usePwdUserSettingsMultipleEndpoint();
  const handleChange = (e: React.SyntheticEvent, newValue) => {
    setValue(newValue);
  };

  return (
    <div style={{ paddingTop: '12px' }}>
      <Tabs value={value} onChange={handleChange}>
        {Object.values(TabType).map((tabItem, index) =>
          !isSDBAccount() &&
          (tabItem === 'SSO_SETTINGS' ||
            tabItem === 'PWD_STRATEGY_SETTINGS') ? null : (
            <Tab key={index} value={tabItem} label={t(`tabs.${tabItem}`)} />
          )
        )}
      </Tabs>
      {isFetching ? (
        <Skeleton />
      ) : (
        <TabSwitcher
          userAndPwdSettings={userAndPwdSettings}
          currentTab={value}
        />
      )}
    </div>
  );
};

export default UserAndPassword;
